import React, { useEffect, useState } from "react";
import { fetchAffiliates } from "@/lib/api";
import { ArrowUpRight, Building2 } from "lucide-react";

export default function AffiliatesPanel() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchAffiliates().then(setData).catch(() => setData(null));
  }, []);

  if (!data) return null;

  return (
    <section data-testid="affiliates-panel" className="py-20 lg:py-24 bg-[#F0EFEA]/40 border-y border-[#E5E2DC]">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="text-[11px] tracking-[0.22em] uppercase text-[#5C6B62] font-semibold inline-flex items-center gap-2">
          <Building2 size={12} /> ready to start?
        </div>
        <h2 className="font-display mt-3 text-3xl sm:text-4xl tracking-tight font-medium text-[#1C2B23]">
          Three honest places to open an account.
        </h2>
        <p className="mt-4 text-[#5C6B62] max-w-2xl">
          All three offer broad-market index funds with rock-bottom expense ratios — the cheapest path to actually implementing the allocation in your plan.
        </p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {data.brokerages.map((b) => (
            <a
              key={b.id}
              data-testid={`affiliate-${b.id}`}
              href={b.url}
              target="_blank"
              rel="noopener nofollow sponsored"
              className="group bg-white border border-[#E5E2DC] rounded-2xl p-6 hover:border-[#2B5339] hover:shadow-sm transition-all"
            >
              <div className="flex items-start justify-between mb-3">
                <span
                  className="inline-flex items-center justify-center w-9 h-9 rounded-full text-white font-display text-base"
                  style={{ background: b.color }}
                >
                  {b.name[0]}
                </span>
                <ArrowUpRight size={16} className="text-[#5C6B62] group-hover:text-[#2B5339] transition-colors" />
              </div>
              <div className="font-display text-xl text-[#1C2B23]">{b.name}</div>
              <div className="text-[11px] tracking-[0.16em] uppercase text-[#5C6B62] font-semibold mt-1">
                {b.tag}
              </div>
              <p className="text-sm text-[#5C6B62] mt-3 leading-relaxed">{b.blurb}</p>
            </a>
          ))}
        </div>
        <p className="text-[11px] text-[#5C6B62] italic mt-6 max-w-3xl leading-relaxed">
          {data.disclosure}
        </p>
      </div>
    </section>
  );
}
